export default __webpack_public_path__ + "static/media/service3.441acce4.png";